/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/habitation': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.478 0 0 4.477 0 10s4.478 10 10 10 10-4.477 10-10S15.522 0 10 0zm5 16H5V9.789l5-5.031 5 5.031V16zm2-5.234a.744.744 0 01-.53-.22L10 4.076l-6.47 6.47a.75.75 0 11-1.061-1.061l7-7a.75.75 0 011.061 0l7 7a.75.75 0 01-.53 1.281z"/>'
  }
})
